import { Version } from '@api/fbe/core/Version';

const BASE_MINOR_VERSION = 60;

export const FeatureAccess: Record<string, Version> = {
    legalDocuments: new Version(0, 65, 150, 466),
};

export const isFeatureAccessible = ({
    featFirstVersion,
    backendVersion,
}: {
    featFirstVersion: Version;
    backendVersion: Version | null;
}): boolean => {
    // Early return for null backend version
    if (!backendVersion) return true;

    // LOCALHOST mode (Revision and Build both 0)
    if (backendVersion.Revision === 0 && backendVersion.Build === 0) {
        return true;
    }

    // Compare major
    if (backendVersion.Major !== featFirstVersion.Major) {
        return backendVersion.Major > featFirstVersion.Major;
    }

    // LOCALHOST or DEV env (minor expected 1 first digit example beMinorFirstDigit)
    if (backendVersion.Minor < BASE_MINOR_VERSION) {
        return true;
    }

    return backendVersion.Minor >= featFirstVersion.Minor;
};
